// ── Quién está abierto en el borde derecho ───────────────────────────────────
//
// Eduardo (2026-09-12): el `?` de la ayuda convive con el dock de Evo Brain en
// el mismo borde —«es el mismo gesto y el mismo lugar»— y **uno reemplaza al
// otro**: dos paneles anclados al mismo lado, abiertos a la vez, se pelean por
// la pantalla.
//
// La exclusión vive acá y no en cada componente. Si la resolviera cada uno,
// habría que acordarse de cerrarlo desde el otro, y ese es el tipo de acuerdo
// que se rompe la tercera vez que alguien toca uno de los dos.

import { useCallback } from 'react';
import { useUiFlag } from './useUiPrefs.js';
import { rutaAModulo } from '../lib/rutaAModulo.js';

export function useAyudaPanel() {
  const [abierta, setAbierta] = useUiFlag('ayuda.abierta', false);
  // `assistant.collapsed` es la misma bandera que usa AssistantShell: true =
  // cerrado. Abrir la ayuda lo colapsa.
  const [, setAsistenteColapsado] = useUiFlag('assistant.collapsed');

  const abrir = useCallback(() => {
    setAsistenteColapsado(true);
    setAbierta(true);
  }, [setAbierta, setAsistenteColapsado]);

  const cerrar = useCallback(() => { setAbierta(false); }, [setAbierta]);

  const alternar = useCallback(() => {
    if (abierta) cerrar();
    else abrir();
  }, [abierta, abrir, cerrar]);

  return { abierta, abrir, cerrar, alternar };
}

export { rutaAModulo };
